import React, { Fragment, useState } from "react";
import { useMount, useWindowSize } from "react-use";
import {
  RadioResultForm,
  CheckboxResultForm,
  RatingResultForm,
  TextResultForm,
} from "../../components/survey/SurveyResultForms";
import { useQueryClient } from "react-query";
import { useLocationQuery } from "../../util/common";
import { getSurveyResults } from "../../api";
import { useParams } from "react-router-dom";

const SurveyResultPage = () => {
  const queryClient = useQueryClient();
  const { id: lecture_id } = useParams();
  const query = useLocationQuery();
  const { target } = query;
  const { width } = useWindowSize();
  let height = 200;
  if (width < 400) {
    height = 100;
  }
  const [studentResults, setResults] = useState(null);

  useMount(async () => {
    const result = await queryClient.fetchQuery(["survey/results"], {
      queryFn: () => getSurveyResults({ lecture_id, target }),
    });
    if (result.result) {
      setResults(result.data);
    }
  });
  return (
    <section className="min-h-screen overflow-y-auto md:mt-4">
      {studentResults && (
        <div className="w-full mx-auto shadow-md overflow-hidden md:rounded-lg md:w-9/12">
          <div className="p-4 bg-cyan-500 ">
            <div className="mx-auto lg:w-full lg:mx-0">
              <div className="inline-flex items-center space-x-4 w-full">
                <h1 className="break-keep text-3xl text-white font-bold p-2 w-full">
                  {studentResults.title}
                </h1>
              </div>
            </div>
            <div className="flex flex-col gap-1 mt-2">
              <div className="flex flex-row gap-2">
                <div className="stat bg-zinc-100 rounded-md p-2 w-1/3 md:p-4">
                  <div className="stat-value text-cyan-500 text-2xl">
                    {studentResults.summary.response}
                  </div>
                  <div className="stat-desc opacity-100">응답</div>
                </div>
                <div className="stat bg-zinc-100 rounded-md p-2 w-1/3 xs:max-w-none md:p-4">
                  <div className="stat-value text-cyan-500 text-2xl">
                    {studentResults.summary.time}
                  </div>
                  <div className="stat-desc opacity-100">
                    완료하는 데 걸린 평균 시간
                  </div>
                </div>
                <div className="stat bg-zinc-100 rounded-md p-2 w-1/3">
                  <div className="stat-value text-cyan-500 text-2xl">
                    {studentResults.summary.active ? "활성화" : "비활성화"}
                  </div>
                  <div className="stat-desc opacity-100">상태</div>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-6 bg-white">
            <hr />
            <ol className="w-full p-4 mx-2 space-y-4 list-decimal">
              {studentResults.list.map(({ q, a }, i) => (
                <li
                  className={`mx-4 mb-8 font-semibold text-black w-10/12 ${
                    i === 4 && "legend-free"
                  }`}
                  key={`${i}_${q}`}
                >
                  {q.content &&
                    q.content.map((v, j) => (
                      <Fragment key={`q_${i}_${j}`}>
                        <span
                          className={j > 0 ? "block break-keep" : "break-keep"}
                        >
                          {v}
                        </span>
                      </Fragment>
                    ))}
                  {q.type === "radio" && (
                    <RadioResultForm {...{ ...a, height }} />
                  )}
                  {q.type === "checkbox" && (
                    <CheckboxResultForm {...{ ...a, height }} />
                  )}
                  {q.type === "rating" && (
                    <RatingResultForm {...{ ...a, height }} />
                  )}
                  {q.type === "textarea" && (
                    <TextResultForm {...{ ...a, height }} />
                  )}
                </li>
              ))}
            </ol>
          </div>
        </div>
      )}
    </section>
  );
};

export default SurveyResultPage;
